<template>
  <div class="underLogoPhrase">
    <h2 class="font-weight-bold mb-4 centers">Qui sommes-nous</h2>
  </div>

  <div class="container" style="margin-top: 20px;">

    <p v-html="formattedPresentation"></p>

  </div>
</template>

<style>
.video-wrapper {
  position: relative;
  width: 100%;
}

.video-wrapper iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.video-fallback {
  margin-top: 14px;
  font-size: 14px;
  color: #333;
}

.video-fallback a {
  color: #1a73e8;
  text-decoration: underline;
}

.video-wrapper a {
  position: relative;
  display: block;
  text-decoration: none;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 48px;
  color: white;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s;
}

.play-button:hover {
  background: rgba(0, 0, 0, 0.9);
}
</style>

<script>
export default {
  data() {
    return {
 informations: {}
    };
  },

  mounted() {
    const idSite = this.$idSite;

    fetch(`https://admin.asso-refuge.fr/getInformations/${idSite}`)
      .then(response => response.json())
      .then(data => {
        if (data && data.length > 0) {
          console.log(data);
          
          this.informations = data[0];
        }
      })
      .catch(error => {
        console.error('Erreur getInformations:', error.message);
      });
  },

  computed: {
    formattedPresentation() {
      if (this.informations && this.informations.presentation) {
        let decoded = this.decodeHtml(this.informations.presentation);

        decoded = decoded
          .replace(/<br\s*\/?>/gi, '')
          .replace(/&nbsp;/gi, ' ')
          .trim();
        return decoded;
      }

      return '';
    }
  },

  methods: {
    decodeHtml(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }
  }
};
</script>

<style src="../assets/css/besoins.css"></style>
